import { debounce } from 'lodash-es'
import { useDefaultModal } from './defaultModal'
import type { ShareParams } from '~/api/interface'
import { ShareLink } from '~/features/template/components/shareLink'
import { Share } from '~/features/template/components/share'

export const getShareUrl = (record: Record<string, any>) => {
  if (record.resource_type === RESOURCE_TYPE.PERSON) {
    return `${location.origin}/3d-avatar/${record.identity}.html`
  }
  const url = record.lastGenerate?.video_url || record.url?.[0]
  const suffix = url?.split('?')?.[0]?.split('.')?.pop()?.toLowerCase()
  if (['mov', 'mkv'].includes(suffix)) {
    return record.lastGenerate?.video_url || record.url?.[0]
  }

  const data = `${Number(record?.user_id).toString(16)}_${
    record?.task_id || record?.generate_record_task_task_id
  }`

  return `${location.origin}/pieces/${record.id}.html?token=${data}`
}

export const getOutShareUrl = (record: Record<string, any>) => {
  // 调整为视频播放路径
  return record.lastGenerate?.video_url || record.url?.[0]
}

// 分享
export const useShareModal = debounce(
  (
    title: string,
    params: ShareParams,
    options: {
      hasShare?: boolean
      linkUrl?: string
      outLinkUrl?: string
      trackParams?: any
    } = { hasShare: true }
  ) => {
    const { $t } = useNuxtApp()

    const modal = useDefaultModal({
      title,
      width: 420,
      footer: false,
      center: true,
      content: (
        <div class="p-[16px_30px]">
          {options.hasShare && (
            <Share params={params} trackParams={options?.trackParams} />
          )}
          {options.linkUrl && (
            <ShareLink
              name={$t(
                'fen-xiang-gei-you-yan-fu-wu-ping-tai-nei-de-qi-ta-yong-hu'
              )}
              event={TRACK_EVENT.YOUYAN_PLATFORM_SHARE}
              url={options.linkUrl}
              trackParams={options?.trackParams}
            />
          )}
          {options.outLinkUrl && (
            <div class="mt-[20px]">
              <ShareLink
                name={$t('fen-xiang-gei-you-yan-fu-wu-ping-tai-wai-de-yong-hu')}
                url={options.outLinkUrl}
                event={TRACK_EVENT.YOUYAN_PLATFORM_SHARE}
                trackParams={options?.trackParams}
              />
            </div>
          )}
        </div>
      ),
    })
    return modal
  },
  200
)
